import Box from "@mui/material/Box";
import {Button, Grid, Link} from "@mui/material";
import {CheckCircle, Close} from "@mui/icons-material";
import {useNavigate, useParams} from "react-router";
import useSuggestionRepository from "../../../../../repository/assignment/useSuggestionRepository";
import {useEffect} from "react";
import useConfirmCustom from "../../../../../use/useConfirmCustom";
import Suggestion from "../../../../../entity/assignment/Suggestion";
import Typography from "@mui/material/Typography";
import route from "../../../../../enum/route";
import parameter from "../../../../../enum/parameter";

export default function () {
    const navigate = useNavigate();
    const {token} = useParams();
    const {confirmModal, managedConfirm} = useConfirmCustom();
    const suggestionRepository = useSuggestionRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();

    useEffect(() => {
        suggestionRepository.findOneByToken(token).exec();
    }, []);

    const accept = () => {
        const handler = () => {
            suggestionRepository.update(suggestion.getId(), "status", {
                suggestion: {
                    status: Suggestion.STATUS_ACCEPTED,
                    artisan_id: suggestion.getArtisanId()
                }
            });
        }

        managedConfirm(
            "Vous allez accepter l'intervention",
            (
                <Typography mt={3} variant="caption" gutterBottom sx={{display: 'block'}}>
                    En acceptant, je m'engage à respecter le <Link
                    href={"https://fairfair-assets.s3.eu-west-3.amazonaws.com/cgv-depanneurs.pdf"}>contrat
                    de partenariat</Link>
                </Typography>
            ),
            handler
        )
    }

    const refuse = () => {
        const handler = async () => {
            const success = await suggestionRepository.update(suggestion.getId(), "status", {
                suggestion: {
                    status: Suggestion.STATUS_REFUSED
                }
            });

            if (success) {
                setTimeout(() => {
                    navigate(route.ENTREPRENEUR_SUGGESTIONS);
                }, 1000);
            }
        }

        managedConfirm(
            "Vous allez refuser l'intervention",
            null,
            handler
        )
    }

    return (
        <Box
            position={"sticky"}
            bottom={0}
            width={"100%"}
        >
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <Button
                        startIcon={<Close/>}
                        variant="contained"
                        color={"error"}
                        fullWidth
                        size={"large"}
                        sx={{borderRadius: 0, height: parameter.FOOTER_HEIGHT}}
                        onClick={refuse}
                        data-test="button-refuse-suggestion"
                    >
                        Refuser
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button
                        startIcon={<CheckCircle/>}
                        variant="contained"
                        color={"primary"}
                        fullWidth
                        size={"large"}
                        sx={{borderRadius: 0, height: parameter.FOOTER_HEIGHT}}
                        onClick={accept}
                        data-test="button-accept-suggestion"
                    >
                        Accepter
                    </Button>
                </Grid>
            </Grid>

            {confirmModal}
        </Box>
    );
}
